import { Component } from '@theme/component';

/**
 * Filters chef collaboration cards by their linked mythology.
 *
 * @typedef {object} Refs
 * @property {HTMLButtonElement[]} [filterButtons]
 * @property {HTMLElement[]} [cards]
 * @property {HTMLElement} [status]
 *
 * @extends Component<Refs>
 */
class ChefCollabsPageComponent extends Component {
  /**
   * @param {Event} event
   */
  filter(event) {
    event.preventDefault();

    const button = event.target;

    if (!(button instanceof HTMLButtonElement)) return;

    this.#setFilter(button.dataset.filterValue || 'all');
  }

  /**
   * @param {string} filterValue
   */
  #setFilter(filterValue) {
    const filterButtons = this.refs.filterButtons || [];
    const cards = this.refs.cards || [];
    const activeFilter = filterValue || 'all';
    let visibleCount = 0;
    let activeLabel = '';

    for (const button of filterButtons) {
      const isActive = (button.dataset.filterValue || 'all') === activeFilter;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive.toString());

      if (isActive) {
        activeLabel = button.textContent?.trim() || '';
      }
    }

    for (const card of cards) {
      const shouldShow = activeFilter === 'all' || card.dataset.ingredient === activeFilter;

      card.hidden = !shouldShow;

      if (shouldShow) visibleCount += 1;
    }

    this.#announce(activeFilter, activeLabel, visibleCount);
  }

  /**
   * @param {string} filterValue
   * @param {string} activeLabel
   * @param {number} visibleCount
   */
  #announce(filterValue, activeLabel, visibleCount) {
    const { status } = this.refs;

    if (!(status instanceof HTMLElement)) return;

    status.textContent =
      filterValue === 'all'
        ? `${visibleCount} chef collaborations shown.`
        : `${visibleCount} chef collaborations shown for ${activeLabel}.`;
  }
}

if (!customElements.get('chef-collabs-page-component')) {
  customElements.define('chef-collabs-page-component', ChefCollabsPageComponent);
}
